import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerHeader from "ds/components/Drawer/Header";
import Box from "ds/components/Box";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import TileWrapper from "ds/components/Tile/Wrapper";
import TileContent from "ds/components/Tile/Content";
import TileTitle from "ds/components/Tile/Title";
import Badge from "ds/components/Badge";

import {
  GITHUB_PERMISSIONS_NAMES,
  GITHUB_PERMISSIONS_DETAILS,
  GITHUB_PERMISSIONS_LEVELS,
} from "./constants";
import { GithubPermissions } from "../types";

type StatusCheckPermissionsDrawerProps = {
  items: GithubPermissions[];
};

const StatusCheckPermissionsDrawer = createDrawer(
  ({ items }: StatusCheckPermissionsDrawerProps) => {
    return (
      <DrawerSimple>
        <DrawerHeader justify="between">
          <DrawerHeaderTitle title="Permissions" />
          <DrawerCloseIcon />
        </DrawerHeader>
        <DrawerBody>
          <Box direction="column" gap="medium">
            {items.map((item, index) => (
              <TileWrapper key={index} gap="small">
                <TileContent gap="small" direction="row" align="center" justify="between">
                  <TileTitle>{GITHUB_PERMISSIONS_NAMES[item]}</TileTitle>
                  <Badge
                    variant={
                      GITHUB_PERMISSIONS_DETAILS[item] === GITHUB_PERMISSIONS_LEVELS.Read
                        ? "blue"
                        : "green"
                    }
                    type="weak"
                    text={GITHUB_PERMISSIONS_DETAILS[item]}
                  />
                </TileContent>
              </TileWrapper>
            ))}
          </Box>
        </DrawerBody>
      </DrawerSimple>
    );
  }
);

export const showStatusCheckPermissionsDrawer = createDrawerTrigger(StatusCheckPermissionsDrawer);
